import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Style.
 */

export interface VisitorCellsHeaderProps {
  hasVisitorExperienceV3?: boolean;
}

interface WrapperStyleProps {
  $hasVisitorExperienceV3?: boolean;
}

const StyledWrapperDiv = styled.div<WrapperStyleProps>`
  height: 30px;
  padding: 9px 10px;
  background-color: ${(p) => p.theme.greys.shade20};
  border-bottom: 1px solid ${(p) => p.theme.greys.shade30};
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
  ${ellipsis()};

  ${(p) =>
    p.$hasVisitorExperienceV3 &&
    css`
      height: auto;
      padding: 9px 16px;
      padding-top: 13px;
      padding-bottom: 0;
      border-color: ${p.theme.greys.shade20};
      justify-content: flex-start;
      display: flex;
      align-items: center;
    `};
`;

/*
 * Component.
 */

export const VisitorCellsHeader: FC<VisitorCellsHeaderProps> = (props) => (
  <StyledWrapperDiv $hasVisitorExperienceV3={props.hasVisitorExperienceV3}>
    <Trans id="cells-sort-options-title-visitor">Conversations</Trans>
  </StyledWrapperDiv>
);
